import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class DeepnessLevelsService
{
  async fetchLevels(): Promise<[any] | null> 
  {
    console.log('fetchRemoteLevels:: cerco livelli idrografici sul server');
    return new Promise((resolve, reject) => {
      const url = `${BASE_URL}/poServer.php?act=20&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('Informazioni sui livelli idrografici scaricarte dal server.');
            resolve(result.content);

            // console.log('fetchLevels :: Scaricati in totale  ', result.length, ' stazioni e relativi dati dal server');
            // console.log('fetchLevels :: ecco i dati  ', result);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sui livelli idrografici - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }
}

export default DeepnessLevelsService;